import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="space-y-4" data-id="element-148">
      {items.map((item, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-149">
          <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none hover:bg-gray-50 transition-colors" aria-expanded={openIndex === index} data-id="element-150">
            <span className="font-serif font-medium text-lg text-caces-navy" data-id="element-151">
              {item.question}
            </span>
            <span className={`ml-4 flex-shrink-0 text-caces-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-152">
              {openIndex === index ? <Minus size={20} data-id="element-153" /> : <Plus size={20} data-id="element-154" />}
            </span>
          </button>

          <div className={`
              overflow-hidden transition-all duration-300 ease-in-out
              ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}
            `} data-id="element-155">
            <div className="p-5 pt-0 text-gray-600 leading-relaxed border-t border-gray-100 mt-2" data-id="element-156">
              {item.answer}
            </div>
          </div>
        </div>)}
    </div>;
}